import { useEffect } from "react";
import "./MainContent.scss";
import { MdFlashOn } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { getPosts } from "../../redux/features/post/postSlice";
import { Link, useNavigate } from "react-router-dom";

import moment from "moment";
import DOMPurify from "dompurify";
import { shortenText } from "../../utils";
const MainContent = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPosts());
  }, [dispatch]);

  const navigate = useNavigate();

  const { posts } = useSelector((state) => state.post);
  const worldNews = posts.find((post) => post?.category === "World News");
  const travel = posts.find((post) => post?.category === "Travel");
  const entertainment = posts.find(
    (post) => post?.category === "Entertainment"
  );
  const national = posts.find((post) => post?.category === "National");

  return (
    <div className="mainContent">
      {/* row left*/}
      <div className="col">
        <div className="row">
          <Link to={`/page/${worldNews?.slug}`}>
            <img src={worldNews?.image} alt="" />
            <Link className="cat">{worldNews?.category}</Link>
            <Link className="icon">
              <MdFlashOn size={20} />
            </Link>

            <div className="postInfo">
              <ul className="nav">
                {/* <li>{worldNews?.author}</li> */}
                <li>{moment(worldNews?.createdAt).format("DD-MMM-YYYY")}</li>
              </ul>
              <Link to={`/page/${worldNews?.slug}`}>
                <h3
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(
                      shortenText(worldNews?.title, 100)
                    ),
                  }}
                ></h3>
              </Link>
            </div>
          </Link>
        </div>
      </div>

      <div className="col">
        <div className="row">
          {/* col right top 1*/}
          <div className="col">
            <div className="row">
              <Link to={`/page/${travel?.slug}`}>
                <img src={travel?.image} alt="" />
                <Link className="cat">{travel?.category}</Link>
                <Link className="icon">
                  <MdFlashOn size={20} />
                </Link>
                <div className="postInfo">
                  <ul className="nav">
                    {/* <li>{travel?.author}</li> */}
                    <li>{moment(travel?.createdAt).format("DD-MMM-YYYY")}</li>
                  </ul>
                  <h3
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(
                        shortenText(travel?.title, 60)
                      ),
                    }}
                  ></h3>
                </div>
              </Link>
            </div>
          </div>

          {/* col right top 2*/}
          <div className="col">
            <div className="row">
              <Link to={`/page/${entertainment?.slug}`}>
                <img src={entertainment?.image} alt="" />
                <Link className="cat">{entertainment?.category}</Link>
                <Link className="icon">
                  <MdFlashOn size={20} />
                </Link>

                <div className="postInfo">
                  <ul className="nav">
                    {/* <li>{entertainment?.author}</li> */}
                    <li>
                      {moment(entertainment?.createdAt).format("DD-MMM-YYYY")}
                    </li>
                  </ul>
                  <h3
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(
                        shortenText(entertainment?.title, 60)
                      ),
                    }}
                  ></h3>
                </div>
              </Link>
            </div>
          </div>
        </div>

        {/* row right bottom */}
        <div className="row">
          <Link to={`/page/${national?.slug}`}>
            <img src={national?.image} alt="" />
            <Link className="cat">{national?.category}</Link>
            <Link className="icon">
              <MdFlashOn size={20} />
            </Link>

            <div className="postInfo">
              <ul className="nav">
                {/* <li>{national?.author}</li> */}
                <li>{moment(national?.createdAt).format("DD-MMM-YYYY")}</li>
              </ul>
              <h3
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(shortenText(national?.title, 90)),
                }}
              ></h3>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};
export default MainContent;
